import HeroSection from "./components/HeroSection"
import ContentSection from "./components/ContentSection"

const ThienTrucBreath: React.FC = () => {
  return (
    <div
      className="min-h-screen"
      style={{ backgroundImage: "url('/background-img.jpg')" }}
    >
      <HeroSection />
      <ContentSection />
    </div>
  )
}

export default ThienTrucBreath
